import { render, staticRenderFns } from "./PayResult.vue?vue&type=template&id=76db298c&"
import script from "./PayResult.vue?vue&type=script&lang=ts&"
export * from "./PayResult.vue?vue&type=script&lang=ts&"
import style0 from "./PayResult.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports